export default __webpack_public_path__ + "static/media/046-anchor.00a547b8.png";